define('model-collections/menu',['underscore', 'backbone', 'classes/templator'],
  function(_, Backbone, templator) {

    var Menu = {};

    Menu.Model = Backbone.Model.extend({
      urlRoot: '/menu',

      defaults: {
      },

      initialize: function () {
      }

    });

    Menu.View = Backbone.View.extend({

      initialize: function() {
        this.render();
      },

      template: templator.menu,

      render: function() {
        this.$el.append(this.template(this.model.attributes));
      }

    });

    return Menu;
  }
);
